import React, { useState } from "react";

export default function AlternateDomains({ data }) {
  const limit = 5;
  const [less, setLess] = useState(true);
  const toggleLess = () => {
    setLess(!less);
  };
  return (
    <div className="border rounded-[14px] overflow-hidden border-input  bg-gray-50 relative mt-4">
      <div className="flex pt-4 pb-3 px-4 justify-between items-center ">
        <span className="text-[16px] text-text-700 mr-3 font-bold">
          Alternative Domains
        </span>
      </div>
      <div className="px-4 mb-4 space-y-2">
        {data &&
          data &&
          data.length > 0 &&
          data.slice(0, less ? limit : data.length).map((domain) => (
            <div>
              <a
                href={`https://${domain?.domain}`}
                className="text-[14px] text-blue-dark-600 mt-1.5"
                target="_blank"
              >
                {domain?.domain}
              </a>
            </div>
          ))}
        {data && data && data.length > 0 && limit < data.length && (
          <div>
            <span
              onClick={toggleLess}
              className="text-brand-700 font-bold text-sm inline-block mt-1 cursor-pointer"
            >
              {less ? "See more" : "See less"}
            </span>
          </div>
        )}
      </div>
    </div>
  );
}
